/* <hy-home-carousel>: looping scroll-snap carousel with autoplay (homepage testimonials).
   Markup: .hhc__track holding 3 copies of the slides ([clone][original][clone]); clones are inert.
   Autoplay moves one slide every data-autoplay ms with a data-speed ms "ease" animation and pauses on hover,
   like the Owl carousel it replaces. Swipe/scroll is native. */
(() => {
  if (customElements.get('hy-home-carousel')) return;
  // cubic-bezier(.25,.1,.25,1) = CSS "ease"
  const ease = (t) => {
    const cx = 0.75, bx = -0.75, ax = 1; // x(u): p1x = p2x = .25
    const cy = 0.3, by = 2.4, ay = -1.7; // y(u): p1y = .1, p2y = 1
    const X = (u) => ((ax * u + bx) * u + cx) * u, Y = (u) => ((ay * u + by) * u + cy) * u;
    let u = t;
    for (let i = 0; i < 8; i++) { const d = (3 * ax * u + 2 * bx) * u + cx; if (Math.abs(d) < 1e-6) break; u -= (X(u) - t) / d; }
    return Y(Math.min(1, Math.max(0, u)));
  };
  class HyHomeCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hhc__track');
      this.count = Number(this.dataset.count) || 0;
      if (!this.track || this.count < 2) return;
      this.delay = Number(this.dataset.autoplay) || 0;
      this.speed = Number(this.dataset.speed) || 600;
      this.hover = false;
      this.addEventListener('mouseenter', () => { this.hover = true; });
      this.addEventListener('mouseleave', () => { this.hover = false; this.restart(); });
      this.track.addEventListener('scroll', () => { clearTimeout(this.st); this.st = setTimeout(() => { if (!this.anim) this.normalize(); }, 120); }, { passive: true });
      this.track.addEventListener('pointerdown', () => this.restart(), { passive: true });
      this.track.addEventListener('touchstart', () => this.restart(), { passive: true });
      new ResizeObserver(() => { const w = this.track.clientWidth; if (w !== this.w) { this.w = w; this.jumpTo(this.index || 0); } }).observe(this.track);
      requestAnimationFrame(() => { this.jumpTo(0); this.restart(); });
    }
    disconnectedCallback() { clearInterval(this.timer); }
    step() { const s = this.track.children; return s.length > 1 ? s[1].getBoundingClientRect().left - s[0].getBoundingClientRect().left : this.track.clientWidth; }
    jumpTo(i) { this.gen = (this.gen || 0) + 1; this.anim = false; this.track.style.scrollSnapType = ''; this.index = ((i % this.count) + this.count) % this.count; this.track.scrollLeft = (this.count + this.index) * this.step(); }
    normalize() {
      const step = this.step(), set = this.count * step, sl = this.track.scrollLeft;
      if (sl < set - step / 2 || sl >= 2 * set - step / 2) this.track.scrollLeft = sl < set ? sl + set : sl - set;
      this.index = Math.round(this.track.scrollLeft / step) - this.count;
    }
    restart() {
      clearInterval(this.timer);
      if (!this.delay || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => { if (!this.hover && !document.hidden) this.next(); }, this.delay);
    }
    next() {
      if (this.anim) return;
      this.normalize();
      const t = this.track, from = t.scrollLeft, to = from + this.step(), start = performance.now(), gen = this.gen = (this.gen || 0) + 1;
      t.style.scrollSnapType = 'none';
      this.anim = true;
      const tick = (now) => {
        if (gen !== this.gen) return;
        const p = Math.min(1, (now - start) / this.speed);
        t.scrollLeft = from + (to - from) * ease(p);
        if (p < 1) return requestAnimationFrame(tick);
        this.anim = false;
        t.style.scrollSnapType = '';
        this.normalize();
      };
      requestAnimationFrame(tick);
    }
  }
  customElements.define('hy-home-carousel', HyHomeCarousel);
})();
